import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiDialog = {
  styleOverrides: {
    paper: ({ theme }) => ({
      border: '1px solid var(--mui-palette-divider)',
      borderRadius: '16px',
      backgroundColor: 'var(--mui-palette-background-paper)',
      boxShadow: theme.shadows[6],
    }),
  },
} satisfies Components<Theme>['MuiDialog'];
